<div class="dialog-wrapper content-creation">
  <h2 *ngIf="isNewVideo" mat-dialog-title>
    {{ "brand.campaign.contentCalendarVideo.create" | translate }}
  </h2>
  <h2 *ngIf="!isNewVideo" mat-dialog-title>
    {{ "brand.campaign.contentCalendarVideo.edit" | translate }}
  </h2>
  <mat-dialog-content>
    <form>
      <section class="upload-image">
        <h3>
          {{ "brand.campaign.contentCalendarVideo.content" | translate }}
          <app-tooltip
            text="{{
              'brand.campaign.contentCalendarVideo.contentTooltip' | translate
            }}"
          ></app-tooltip>
        </h3>
        <div class="video-file-uploaded-name">
          {{ video.videoName }}
        </div>
        <app-file-uploader
          [uploaderTitle]="
            'brand.campaign.contentCalendarVideo.dragDrop' | translate
          "
          uploaderSubtitle="{{
            'brand.campaign.contentCalendarVideo.fileExtensions' | translate
          }} mp4. Max {{ maxFileSizeInMegabytes }} MB"
          (apiResponse)="handleUploadResponse($event)"
          (fileAddedToQueue)="fileAddedToQueue($event)"
          [uploadUrl]="uploadVideoUrl"
          [uploadData]="uploadData"
          [fieldName]="uploaderFieldName"
          [autoUpload]="false"
          [acceptFormat]="acceptFormat"
          (uploadError)="fileUploaderErrorHandler($event)"
          [maxFileSize]="maxFileSizeInBytes"
          [responseMapper]="fileUploaderResponseMapper"
        />
      </section>
      <section class="suggested-text">
        <h3>
          {{ "brand.campaign.contentCalendarVideo.videoTitle" | translate }}
          <app-tooltip
            text="{{
              'brand.campaign.contentCalendarVideo.videoTooltip' | translate
            }}"
          ></app-tooltip>
        </h3>
        <div>
          <mat-form-field class="post-content">
            <mat-label>{{
              "brand.campaign.contentCalendarVideo.titlePlaceholder" | translate
            }}</mat-label>
            <input
              matInput
              (keyup)="updateSaveDisabled()"
              #username="ngModel"
              [(ngModel)]="video.title"
              id="post-content"
              name="post-content"
              type="text"
              tabindex="-1"
              required
            />
            <mat-error
              class="email-error"
              *ngIf="username.errors && username.errors.required"
            >
              {{
                "brand.campaign.contentCalendarVideo.titleRequired" | translate
              }}
            </mat-error>
          </mat-form-field>
        </div>
      </section>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button class="btn btn--transparent" tabindex="-1" [mat-dialog-close]="">
      {{ "shared.cancel" | translate }}
    </button>
    <button
      class="btn btn--primary"
      tabindex="-1"
      (click)="saveContent()"
      [disabled]="isSaveDisabled"
    >
      <span *ngIf="saving">{{ "shared.saving" | translate }}</span>
      <span *ngIf="!saving">{{
        "brand.campaign.contentCalendarVideo.saveVideo" | translate
      }}</span>
    </button>
  </mat-dialog-actions>
</div>
